import { useStorageQuota } from '@office-start/storage-quota-service';
import { StorageAlertLevel } from '@office-start/welcome-badge-types';
import { useMemo } from 'react';
// TODO: Replace Area with supported value for USQ service
export var useIsShowStorageErrorApplicable = function () {
    var storageQuota = useStorageQuota({
        area: 'WelcomeBadge',
        logFullQuota: true,
    });
    var isShowStorageErrorApplicable = useMemo(function () {
        var storageAlertLevel = storageQuota === null || storageQuota === void 0 ? void 0 : storageQuota.storageAlertLevel;
        return storageAlertLevel
            ? storageAlertLevel === StorageAlertLevel.Over ||
                storageAlertLevel === StorageAlertLevel.Full
            : false;
    }, [storageQuota === null || storageQuota === void 0 ? void 0 : storageQuota.storageAlertLevel]);
    return isShowStorageErrorApplicable;
};
//# sourceMappingURL=useIsShowStorageErrorApplicable.js.map